import { render, staticRenderFns } from "./create-task.vue?vue&type=template&id=ca5a0da6&scoped=true&"
import script from "./create-task.vue?vue&type=script&lang=js&"
export * from "./create-task.vue?vue&type=script&lang=js&"
import style0 from "./create-task.vue?vue&type=style&index=0&id=ca5a0da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5a0da6",
  null
  
)

export default component.exports